import { di } from 'react-magnetic-di';
import { JSW_TMP_BACKLOG_BOARD_REGEXP } from '../../common/constants.tsx';

export const shouldDisableGICFlagCreation: () => boolean = () => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return JSW_TMP_BACKLOG_BOARD_REGEXP.test(window.location.pathname);
};
